import { render, staticRenderFns } from "./RestaurantMap.vue?vue&type=template&id=708d7991&scoped=true&"
import script from "./RestaurantMap.vue?vue&type=script&lang=js&"
export * from "./RestaurantMap.vue?vue&type=script&lang=js&"
import style0 from "./RestaurantMap.vue?vue&type=style&index=0&id=708d7991&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708d7991",
  null
  
)

export default component.exports